(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('stockCountApprove', {
        templateUrl: 'views/components/views/stockCountApprove/stockCountApprove.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'stockCountApproveService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, stockCountApproveService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockCountKeyno = $stateParams.stockcount_keyno;
            
            let variableNames = {
                gb_stockcountapprove_main: '',
                filtervalue: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            let progressInfo = {
                progression: '',
                label: '',
                plabel: '',
                field: '',
                remField: '',
                min: 0,
                max: 100,
                step: 0,
                finishclose: ''
            };

    		vm.model = {
                bgStockCountApproveMain: {
                    selected: 'POSSIBLE',
                    buttons: [
                        { id: 'POSSIBLE', label: 'gb_stockcountapprove_main_possible', color: 'primary', onClick: () => setStockCountApproveMainView('POSSIBLE') },
                        { id: 'MANUAL', label: 'gb_stockcountapprove_main_manual', color: 'primary', onClick: () => setStockCountApproveMainView('MANUAL') },
                        { id: 'APPROVED', label: 'gb_stockcountapprove_main_approved', color: 'primary', onClick: () => setStockCountApproveMainView('APPROVED') }
                    ]
                },
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filtervalue') }
                ],
    			setting: {},
    			itemsListPossibles: [],
    			itemsListManuals: [],
    			itemsListApproved: [],
                approving: false
    		};

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region BUTTON GROUP SINGLE FUNCTION

            async function setStockCountApproveMainView(id) {
                vm.model.bgStockCountApproveMain.selected = vm.model.setting.gb_stockcountapprove_main = id;
            }

            // #endregion BUTTON GROUP SINGLE FUNCTION

    		// #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await stockCountApproveService.getSetting())[0];
            }
            
            async function loadPossibles() {
                vm.model.itemsListPossibles = await stockCountApproveService.listPossibles({ stockcount_keyno: stockCountKeyno });
    		}
            
            async function loadManuals() {
                vm.model.itemsListManuals = await stockCountApproveService.listManuals({ stockcount_keyno: stockCountKeyno });
    		}
            
            async function loadApproved() {
                vm.model.itemsListApproved = await stockCountApproveService.listApproved({ stockcount_keyno: stockCountKeyno });
    		}

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case '':
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'gb_stockcountapprove_main':
                    case 'filtervalue':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'filtervalue':
                        vm.model.setting.filtervalue = '';

                        if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgStockCountApproveMain = function (value) {
                vm.model.bgStockCountApproveMain.selected = value;
                vm.model.setting.gb_stockcountapprove_main = vm.model.bgStockCountApproveMain.selected;
                
                rememberFunc('gb_stockcountapprove_main');
            }

            // #endregion BUTTON GROUP SINGLE FUNCTION

    		// #region APPROVE BUTTON FUNCTION
            
            async function approveProgress(items) {
    			let increment = 1, skip = 0, failed = 0, step = 0;
    			progressInfo.step = 0;
    
                function doStep() {
                    setTimeout(() => {
                        modalService.progressInfo.finishclose = '0';

    					if (progressInfo.progression === 'ABORT') return;
    					
                        if (items[step].item_id === '0' || items[step].item_id === '9999') {
                            skip++;
                            step = progressInfo.step + skip + failed;
                            doStep();
                        } else {
                            step = progressInfo.step + skip + failed;
                            progressInfo.field = items[step].item_id + ': ' + items[step].item_name;
                            modalService.progressInfo.field = progressInfo.field;

                            stockCountApproveService.approveItem({ stockcountdata_keyno: items[step].item_id }).then((response) => {
                                if (response[0] && response[0].errorcode !== '0') {
    								modalService.progressInfo.finishclose = '1';
                                    
    								modalService.show({
    									type: 'warning',
                                        title: translations.error,
                                        message: response[0].errormessage,
                                        buttons: [{
                                            label: translations.ok,
    										cssClass: 'btn-warning',
    										action: (dialogItself) => {
                                                dialogItself.close();
                                                vm.model.approving = false;
    										}
    									}]
    								});
                                } else {
                                    vm.model.approving = false;
    								//if response error, failed++;
    								progressInfo.step += increment;
    								modalService.progressInfo.step = progressInfo.step;
    								modalService.progressInfo.finishclose = '1';
    
    								doStep();
    							}
    						});
    					}
    				});
                }

    			doStep();
    		}
            
            vm.approveChanges = function () {
                vm.model.approving = true;

    			progressInfo.progression = 'START';
    			progressInfo.label = 'progressbar';
    			progressInfo.field = '';
    			progressInfo.max = 0;
                progressInfo.step = 0;

                vm.model.itemsListPossibles.forEach((item) => {
    				if (item.item_id !== '0' && item.item_id !== '9999') {
    					progressInfo.max++;
    				}
    			});
                
    			approveProgress(vm.model.itemsListPossibles);
                
                modalService.showProgress(progressInfo).then(function (value) {
    				progressInfo.progression = value;
    				//if (progressInfo.progression === 'ABORT') {
    				//	//run if manually closed before finishing
    				//}
    				//if (progressInfo.progression === 'FINISH') {
    				//	//run if finished and closed
    				//}

                    //this will run when closed regardless of 'ABORT' || 'FINISH'
                    vm.model.approving = false;
    				loadPossibles();
    				loadManuals();
    				loadApproved();
    			});
    		}

            // #endregion APPROVE BUTTON FUNCTION

    		// #region DIRECTION BUTTON FUNCTIONS
            
    		vm.goTo = async function (item) {
    			let variableNameItemManualList = 'w_stockcountapprove.manual_stockcountdata_keyno';
                
                if (utilityService.validateParmsValue(item.item_id) !== true) return;
                
                await rememberService.remember(variableNameItemManualList, item.item_id);
                
    			stateService.go(item.item_state, item.item_parms);
    		}

            // #endregion DIRECTION BUTTON FUNCTIONS

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'filtervalue':
                        if (utilityService.validateParmsValue(vm.model.setting.filtervalue) !== true) return;

                        if (vm.model.setting.filtervalue > '') rememberFunc('filtervalue');
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'filtervalue':
                        if (utilityService.validateWatchValue(value, vm.model.setting.filtervalue) !== true) return;

                        vm.model.setting.filtervalue = value;

                        if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

                        if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                setStockCountApproveMainView(vm.model.setting.gb_stockcountapprove_main);
                loadPossibles();
                loadManuals();
                loadApproved();
            }

            // #endregion ON INIT FUNCTION

    	}]
    });
})();
